"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusHelper = void 0;
var react_1 = __importDefault(require("react"));
/**
 * This component is an invisible input to help with focussing the select component
 * when there is no search field present.
 */
exports.FocusHelper = react_1.default.forwardRef(function (props, ref) {
    return (react_1.default.createElement("input", __assign({ ref: ref, readOnly: true, value: "", tabIndex: 0, style: {
            background: 0,
            border: 0,
            fontSize: "inherit",
            outline: 0,
            padding: 0,
            width: 1,
            color: "transparent",
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(0)",
        } }, props)));
});
//# sourceMappingURL=FocusHelper.js.map